import { gql } from '@apollo/client'

const DELETE_FAKE_BRAND_MUTATION = gql`
  mutation deleteFakeBrandMutation($id: ID!) {
    deleteFakeBrand(id: $id)
  }
`

export default DELETE_FAKE_BRAND_MUTATION
